
import images from "./widget/images"
export default
    {
        "type": "object",
        "properties": {
            "title": {
                "type": "string",
                "ui": {
                    "label": "title"
                }
            },
            "order": {
                "type": "string",
                "default": 0,
                "ui": {
                    "label": "排序(大的靠前)"
                }
            },

            "thumb": images({}),

        }
    }